// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analysis-table{font-family:Quicksand!important;min-width:1000px}.tbl-title-text{max-width:400px;overflow:hidden;text-align:left;white-space:nowrap}h2{padding-top:50px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
